<template>
  <div
    id="warn-tender-update-modal"
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <div
      class="reveal"
      id="alertTenderUpdateModal"
      data-reveal
    >

      <div class="modal-container">
        <p class="confirm-header">{{ $t('vendor.bid.warnUpdate.popupTitle') }}</p>
      </div>
      <span
        class="form-error is-visible appr-error-message"
        v-if="apprErrHint"
      >
        {{ apprErrHint }}
      </span>

      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--orange"
          @click="closeAlertTenderUpdateModal()"
        >{{ $t('no') }}</button>
        <button
          type="button"
          class="btn btn--darkblue"
          @click="refreshPage()"
        >{{ $t('yes') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'WarnTenderUpdate',
  data () {
    return {
      apprErrHint: '',
      approver: '',
      declineReason: '',
    }
  },

  props: {
    className: {
      type: String,
      default: 'btn btn--orange',
    },
  },

  mounted () {
    if (!this.alertTenderUpdateModal) {
      this.alertTenderUpdateModal = new Foundation.Reveal($('#alertTenderUpdateModal'), {
        closeOnEsc: false,
        closeOnClick: false,
      })
    }
  },

  destroyed () {
    if (this.alertTenderUpdateModal) {
      this.alertTenderUpdateModal.destroy()
    }
  },

  methods: {
    closeAlertTenderUpdateModal () {
      this.alertTenderUpdateModal.close()
    },
    openAlertTenderUpdateModal () {
      this.alertTenderUpdateModal.open()
    },
    refreshPage () {
      location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';

</style>
